import { render } from "./PrincipalActiveHoldClientComponent.vue?vue&type=template&id=73a1295a&scoped=true"
import script from "./PrincipalActiveHoldClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalActiveHoldClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalActiveHoldClientComponent.vue?vue&type=style&index=0&id=73a1295a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a1295a"]])

export default __exports__